export const placeholder = {
  defaultSecurityQuestion: "Please select a Question",
  defaultSecurityAnswer: "Answer",
};
